import React from 'react'
import Table from 'react-bootstrap/lib/Table'
import Change from 'react-icons/lib/md/code'

import acc from 'accounting'

import withChangeSection from './hocs/withChangeSection'

const ListSubjects = ({ data, is_registered, openChangeSection }) => {
  let total = 0

  return (
    <Table>
      <thead>
        <tr>
          <th width='2%'> </th>
          <th width='10%'>Code</th>
          <th width='8%'>Section</th>
          <th>Subject Description</th>
          <th width='20%'>Schedule</th>
          <th width='5%' className='text-right'>
            Lec
          </th>
          <th width='5%' className='text-right'>
            Lab
          </th>
          <th width='5%' className='text-right'>
            Units
          </th>
          <th width='15%'>Instructor</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, k) => {
          total += item.get('units') - 0
          let cl = ''
          let section = <span>{item.get('section')}</span>
          let schedule = <small>{item.get('schedule')}</small>
          let instructor = <small>{item.get('instructor_name')}</small>
          if (item.getIn(['to', 'id'])) {
            cl = 'info'
            section = (
              <div>
                <span>
                  <s>{item.get('section')}</s>
                </span>
                <br />
                <span>{item.getIn(['to', 'section'])}</span>
              </div>
            )
            schedule = (
              <div>
                <small>
                  <s>{item.get('schedule')}</s>
                </small>
                <br />
                <small>{item.getIn(['to', 'schedule'])}</small>
              </div>
            )
            instructor = (
              <div>
                <small>
                  <s>{item.get('instructor_name')}</s>
                </small>
                <br />
                <small>{item.getIn(['to', 'instructor_name'])}</small>
              </div>
            )
          }
          return (
            <tr key={k} className={cl}>
              <td>
                <button
                  type='button'
                  onClick={openChangeSection.bind(this, item)}
                  className='btn-icon'
                  disabled={!is_registered}
                >
                  <Change />
                </button>
              </td>
              <td>
                <code>{item.get('subject_code')}</code>
              </td>
              <td>{section}</td>
              <td>{item.get('subject_name')}</td>
              <td>{schedule}</td>
              <td className='text-right'>
                {acc.formatNumber(item.get('lec_units'), 1)}
              </td>
              <td className='text-right'>
                {acc.formatNumber(item.get('lab_units'), 1)}
              </td>
              <td className='text-right'>
                {acc.formatNumber(item.get('units'), 1)}
              </td>
              <td>{instructor}</td>
            </tr>
          )
        })}
      </tbody>
      <tfoot>
        <tr>
          <th colSpan='7' className='text-right'>
            Total Units:
          </th>
          <th className='text-right'>{acc.formatNumber(total, 1)}</th>
          <th />
        </tr>
      </tfoot>
    </Table>
  )
}

export default withChangeSection(ListSubjects)



// WEBPACK FOOTER //
// ./src/containers/COR/list-subjects.js